import { FormField } from '@/components/templates/entity-form'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

export interface CreateAssociationForm {
  profile: string
  name: string
  subdomain: string
  timeZone: string
}

export const associationTimeZones = [
  'America/Los_Angeles',
  'America/New_York',
  'America/Chicago',
  'Europe/London',
]
const locked = 'bg-muted text-foreground cursor-default'
const fab = { name: 'Federation of Awarding Bodies', subdomain: 'fab', timeZone: 'Europe/London' }

export function PlatformAssociationFormFields({
  form,
  onChange,
  errors,
}: {
  form: CreateAssociationForm
  onChange: (form: CreateAssociationForm) => void
  errors: Record<string, string[]>
}) {
  const demo = form.profile === 'fab'
  return (
    <>
      <FormField label="Demo profile" htmlFor="association-demo-profile">
        <Select
          value={form.profile}
          onValueChange={(profile) =>
            onChange({
              profile,
              ...(profile === 'fab' ? fab : { name: '', subdomain: '', timeZone: '' }),
            })
          }
        >
          <SelectTrigger id="association-demo-profile">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="none">None (real association)</SelectItem>
            <SelectItem value="fab">FAB — Federation of Awarding Bodies</SelectItem>
          </SelectContent>
        </Select>
        <p className="mt-1.5 text-body-sm text-muted-foreground">
          A demo profile creates a demo association full of sample data. No email leaves it.
        </p>
      </FormField>
      <FormField label="Name" htmlFor="association-name" required error={errors.name?.[0]}>
        <Input
          id="association-name"
          placeholder="Riverside Trade Assoc."
          value={form.name}
          readOnly={demo}
          className={demo ? locked : undefined}
          onChange={(event) => onChange({ ...form, name: event.target.value })}
        />
      </FormField>
      <FormField
        label="Subdomain"
        htmlFor="association-subdomain"
        required
        hint="Lowercase · unique · permanent"
        error={errors.web_address_name?.[0]}
      >
        <Input
          id="association-subdomain"
          placeholder="riverside"
          value={form.subdomain}
          onChange={(event) => onChange({ ...form, subdomain: event.target.value })}
        />
      </FormField>
      <FormField
        label="Time zone"
        htmlFor="association-time-zone"
        required
        error={errors.time_zone?.[0]}
      >
        <Select
          value={form.timeZone}
          disabled={demo}
          onValueChange={(timeZone) => onChange({ ...form, timeZone })}
        >
          <SelectTrigger
            id="association-time-zone"
            className={demo ? `${locked} disabled:opacity-100` : undefined}
          >
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {associationTimeZones.map((zone) => (
              <SelectItem key={zone} value={zone}>
                {zone}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FormField>
      {demo && (
        <FormField label="Currency" htmlFor="association-currency">
          <Input id="association-currency" readOnly className={locked} value="GBP" />
        </FormField>
      )}
    </>
  )
}
